@if (initialized && activeNavigationItem) {
    <div class="config-content-container surface-0">

        @if (activeNavigationItem?.action === 'xx.XxSimpleTestEntity') {
            <div class="h-full p-2 pt-0 scroll-table-container">
                @if (widgets?.simpleTestWidget) {
                    <mvs-widget
                            [widgetData]="widgets?.simpleTestWidget.widgetData"
                            (onObjectSelect)="handleEntitySelect($event)">
                    </mvs-widget>
                }
            </div>
        }

        @if (activeNavigationItem?.action === 'xx.XxCarPilotCarType') {
            <div class="grid h-full m-0">
                <div class="col-12 md:col-4 lg:col-3 h-full p-2 pt-0 scroll-sidebar-container">
                    @if (widgets?.xxCarPilotCarTypeSelectableWidget) {
                        <mvs-widget
                                [widgetData]="widgets?.xxCarPilotCarTypeSelectableWidget.widgetData"
                                (onObjectSelect)="onCarPilotCarTypeSelect($event)"
                                (onObjectDeselect)="onCarPilotCarTypeDeselect()">
                        </mvs-widget>
                    }
                </div>
                <div class="col-12 md:col-8 lg:col-9 h-full p-2 pt-0 scroll-table-container">
                    @if (xxCarPilotCarTypeFieldWidget) {
                        <mvs-widget
                                [widgetData]="xxCarPilotCarTypeFieldWidget"
                                (onObjectSelect)="handleEntitySelect($event)">
                        </mvs-widget>
                    }
                </div>
            </div>
        }

        @if (activeNavigationItem?.action === 'xx.XxGenericTestType') {
            <div class="grid h-full m-0">
                <div class="col-12 md:col-4 lg:col-3 h-full p-2 pt-0 scroll-sidebar-container">
                    @if (widgets?.xxGenericTestTypeSelectableWidget) {
                        <mvs-widget
                                [widgetData]="widgets?.xxGenericTestTypeSelectableWidget.widgetData"
                                (onObjectSelect)="onGenericTestTypeSelect($event)"
                                (onObjectDeselect)="onGenericTestTypeDeselect()">
                        </mvs-widget>
                    }
                </div>
                <div class="col-12 md:col-8 lg:col-9 h-full p-2 pt-0 scroll-table-container">
                    @if (xxGenericTestTypeFieldWidget) {
                        <mvs-widget
                                [widgetData]="xxGenericTestTypeFieldWidget"
                                (onObjectSelect)="handleEntitySelect($event)">
                        </mvs-widget>
                    }
                </div>
            </div>
        }

    </div>
}
